import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const MobileSearchMenuPopularSearchesHolder = styled.div`
  background: ${colors.inputGrey};
  border-top: 1px solid ${colors.selectionGrey};
  padding: 36px 24px;
  flex: 1;
`;

export const MobileSearchMenuPopularSearchesBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const MobileSearchMenuPopularSearchesLinkWithIcon = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;
